<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage">
<a id="title27"></a>
<div class="p-c"><span><strong class="b">For Michael and Terry Paling</strong></span></div></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429982559_ded01.vue?25f8830f